import { render, staticRenderFns } from "./switchUserOutlet.vue?vue&type=template&id=4a3a1bf6&scoped=true&"
import script from "./switchUserOutlet.vue?vue&type=script&lang=js&"
export * from "./switchUserOutlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a1bf6",
  null
  
)

export default component.exports